/**
 * 底部
 */

import * as React from 'react'
import { Trans } from '@/libs/next-lang'
import styles from './index.module.less'

export default function Index({ url, translateTxt }: any) {
  return (
    <div className={styles.footer}>
      <div className={styles.wrap}>
        <div className={styles.logo}>
          <img draggable={false} src={url} alt="logo" />
        </div>
        <div className={styles.section}>
          <span className={styles.company}>{translateTxt('footer:t1')}</span>
          <div className={styles.record}>
            <span>© 2020-2023</span>
            &ensp;
            <span>{translateTxt('footer:t2')}</span>
            &ensp;
            <span>{translateTxt('footer:t3')}</span>
          </div>
          &ensp;
          <span
            className={styles.icp}
            onClick={() => {
              window.open('https://beian.miit.gov.cn')
            }}
          >
            {translateTxt('footer:t4')}
          </span>
          &ensp;
          <span className={styles.filing}>
            <Trans i18nKey="t5" ns="footer">
              <img src="https://static.creativebooster.com/ad-web/filing.png" alt="filing" />
              <a
                href="https://beian.mps.gov.cn/#/query/webSearch?code=31010502006700"
                rel="noreferrer"
                target="_blank"
              >
                沪公网安备31010502006700
              </a>
            </Trans>
          </span>
          &ensp;
          <span
            className={styles.protocol}
            onClick={() => {
              window.open('/agreement')
            }}
          >
            {translateTxt('footer:t6')}
          </span>
          丨
          <span
            className={styles.protocol}
            onClick={() => {
              window.open('/policy')
            }}
          >
            {translateTxt('footer:t7')}
          </span>
        </div>
      </div>
    </div>
  )
}
